import * as React from "react";
import {TableCell, TableSortLabel} from "@mui/material";
import {Order, SortableKey} from "../../../../hooks/useJobPositions";

export default function SortCell({label, field, orderBy, order, onSort}: Readonly<{
    label: string;
    field: SortableKey;
    orderBy: SortableKey;
    order: Order;
    onSort: (f: SortableKey) => void;
}>): React.ReactElement {
    return (
        <TableCell sortDirection={orderBy === field ? order : false}>
            <TableSortLabel
                active={orderBy === field}
                direction={orderBy === field ? order : "asc"}
                onClick={() => onSort(field)}
            >
                {label}
            </TableSortLabel>
        </TableCell>
    );
}
